/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authloginsignuplink4Inputs */



/**
* | output |
* | --- |
* | "Create one" |
*
* @param {Authloginsignuplink4Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authloginsignuplink4 = /** @type {((inputs?: Authloginsignuplink4Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authloginsignuplink4Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Create one")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("Créer un compte")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Erstellen Sie eins")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("建立帳戶")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("계정 만들기")
	return /** @type {LocalizedString} */ ("登録する")
});
export { authloginsignuplink4 as "authLoginSignUpLink" }